import {
  Accordion,
  Box,
  Flex,
  StarCircledIcon,
  Typography,
  useMobileMediaQuery,
} from '@iheartjane/reefer';

import { AddInfoPrompt } from '@jane/monolith/components/cart/pendingCartDrawer/cartDrawerSpecials/addInfoPrompt';
import { BoxWrapper } from '@jane/monolith/components/cart/pendingCartDrawer/cartDrawerSpecials/cartDrawerSpecials';
import { LoginProtected } from '@jane/monolith/components/cart/pendingCartDrawer/cartDrawerSpecials/loginProtected';

interface CustomerLoyaltyPointsGuestProps {
  isHeadless?: boolean;
  signedIn?: boolean;
  storeRewardLabel?: string | null;
}

export const CustomerLoyaltyPointsGuest = ({
  isHeadless,
  signedIn = false,
  storeRewardLabel,
}: CustomerLoyaltyPointsGuestProps) => {
  const isMobile = useMobileMediaQuery({});
  const rewardsTitle = `Use store ${
    storeRewardLabel ? storeRewardLabel : 'rewards'
  }`;

  if (isHeadless) {
    return (
      <BoxWrapper>
        <Typography
          variant="header-bold"
          branded
          mb={24}
          // eslint-disable-next-line react/forbid-component-props -- legacy emotion
          css={{ wordBreak: 'break-word' }}
        >
          {rewardsTitle}
        </Typography>
        {signedIn ? (
          <AddInfoPrompt rewardsLabel={storeRewardLabel} />
        ) : (
          <LoginProtected rewardsLabel={storeRewardLabel} isRewards />
        )}
      </BoxWrapper>
    );
  }

  return (
    <Accordion.Item id="store-rewards">
      <Accordion.Heading px={isMobile ? 24 : 40} py={20}>
        <Flex alignItems="center" justifyContent="space-between">
          <Flex alignItems="center">
            <div>
              <StarCircledIcon />
            </div>
            <Typography variant="body-bold" ml={16}>
              {rewardsTitle}
            </Typography>
          </Flex>
          <Flex pl={16}>
            <Accordion.Indicator iconSize="md" />
          </Flex>
        </Flex>
      </Accordion.Heading>
      <Accordion.Content px={isMobile ? 24 : 40} destroyOnClose>
        <Box pl={40}>
          {signedIn ? (
            <AddInfoPrompt rewardsLabel={storeRewardLabel} />
          ) : (
            <LoginProtected rewardsLabel={storeRewardLabel} isRewards />
          )}
        </Box>
      </Accordion.Content>
    </Accordion.Item>
  );
};
